import im from 'immutable';

export default im.Record({
  path: null,
  mutable: false,
  required: true,
  default: null,
  resolve: null,
  define: null,
  validate() {
    return false;
  },
});

const descriptors = new WeakMap();

function getDescriptor(schema, name) {
  const d = descriptors.get(schema);
  if (d) {
    return d[name];
  }
  return null;
}

function getAllDescriptors(schema) {
  return descriptors.get(schema);
}

function setDescriptor(schema, name, descriptor) {
  const d = descriptors.get(schema);
  if (d) {
    d[name] = descriptor;
  } else {
    descriptors.set(schema, {
      [name]: descriptor,
    });
  }
}

export { getDescriptor, getAllDescriptors, setDescriptor };
